<!-- Template to expose the current action button to parent -->
<ng-template #accountSetupActionButton>
  <ng-container *ngTemplateOutlet="currentActionButtonTemplate()"></ng-container>
</ng-template>

<div class="account-setup-wrapper">
  <span class="scroll-anchor" #scrollAnchor></span>
  @if (user() && !processing() && !isLoadingPaymentPageData()) {
    @if (!useInSessionRequest() && !isProposeATime() && !onCostEstimation() && !fromDirectBooking()) {
      <client-setup-progress-bar
        [showProgress]="true"
        [progressBarValue]="progressBarValue"
        [progressBarHeader]="progressBarHeader"
      ></client-setup-progress-bar>
    }
    @if (onBasicInfo()) {
      <client-setup-basic-info
        #basicInfoComponent
        [useInSessionRequest]="useInSessionRequest()"
        [isProposeATime]="isProposeATime()"
        [isMobile]="isMobile()"
        (basicInfoSubmitted)="setupDataSubmitted()"
        [fromDirectBooking]="fromDirectBooking()"
      ></client-setup-basic-info>
    }
    @if (onEAP()) {
      <client-setup-eap-info
        #eapInfoComponent
        [useInSessionRequest]="useInSessionRequest()"
        [isMobile]="isMobile()"
        [isProposeATime]="isProposeATime()"
        [user]="user()"
        [fromDirectBooking]="fromDirectBooking()"
        (eapInfoSubmitted)="setupDataSubmitted($any($event))"
        (eapSkippedToInsurance)="eapToInsurance()"
      ></client-setup-eap-info>
    }
    @if (onInsurance()) {
      <client-setup-insurance-info
        #insuranceInfoComponent
        [useInSessionRequest]="useInSessionRequest()"
        [isProposeATime]="isProposeATime()"
        [isMobile]="isMobile()"
        [user]="user()"
        (insuranceInfoSubmitted)="setupDataSubmitted($event)"
        [costEstimateContext]="costEstimateContext()"
        [fromDirectBooking]="fromDirectBooking()"
      ></client-setup-insurance-info>
    }
    @if (onInsuranceReview()) {
      <client-insurance-review
        #insuranceReviewComponent
        [useInSessionRequest]="useInSessionRequest()"
        [isMobile]="isMobile()"
        [isEAP]="isEAPReview()"
        [fromDirectBooking]="fromDirectBooking()"
        (closeReview)="setupDataSubmitted()"
      ></client-insurance-review>
    }
    @if (onInsuranceVerificationFailed()) {
      <client-insurance-verification-failed
        #insuranceVerificationFailedComponent
        [isMobile]="isMobile()"
        [fromDirectBooking]="fromDirectBooking()"
        (closeReview)="setupDataSubmitted()"
      ></client-insurance-verification-failed>
    }
    @if (onCostEstimation() && !isSelfPayCostEstimate()) {
      <client-cost-estimation
        #costEstimationComponent
        [accountSetupType]="accountSetupType"
        [fromDirectBooking]="fromDirectBooking()"
        [userHasSuccessfulMostRecentBv]="userHasSuccessfulMostRecentBv"
        (costEstimationReviewed)="onCostEstimationReviewed()"
      ></client-cost-estimation>
    }
    @if (onCostEstimation() && isSelfPayCostEstimate()) {
      <client-self-pay-cost-estimation
        #selfPayCostEstimationComponent
        [fromDirectBooking]="fromDirectBooking()"
        [personaClientId]="user()?.personaId"
        [personaProviderId]="providerPersonaProviderId()"
        [isPsychiatrist]="providerIsPsychiatrist()"
        [isTelehealthAppointment]="isTelehealthAppointment()"
        (costEstimationReviewed)="onCostEstimationReviewed()"
      ></client-self-pay-cost-estimation>
    }
    @if (onPayment()) {
      <client-setup-payment-info
        #paymentInfoComponent
        [useInSessionRequest]="useInSessionRequest()"
        [isMobile]="isMobile()"
        [isProposeATime]="isProposeATime()"
        [showPaymentFaq]="showPaymentFaq"
        (paymentInfoSubmitted)="setupDataSubmitted()"
        [fromDirectBooking]="fromDirectBooking()"
      ></client-setup-payment-info>
    }
    @if (onEbcgPayment()) {
      <client-setup-ebcg-payment-info
        #ebcgPaymentInfoComponent
        [useInSessionRequest]="useInSessionRequest()"
        [providerName]="providerName()"
        [userProfile]="user()?.profile"
        (paymentInfoSubmitted)="setupDataSubmitted()"
        (exitSetup)="setupExited.emit()"
        [fromDirectBooking]="fromDirectBooking()"
      ></client-setup-ebcg-payment-info>
    }
  } @else {
    <iris-spinner size="lg"></iris-spinner>
  }
</div>
